/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-22
 *
 * bestgob-client - auth.api.js
 **/

import {httpClient, httpClientBackend} from './http-client';

import {toFormData} from '../core/utils';
import axios from 'axios';


/**
 *API para traer los estados de mexico
 */
const getEstados = () => httpClient.get('https://agentes.pgjhidalgo.gob.mx/backend/api/get_cat/64');

/**
 *API para traer los municipios de mexico
 */
const getMunicipios = (data) => httpClient.get('https://agentes.pgjhidalgo.gob.mx/backend/api/get_cat/71/cve_agee/', (data));

/**
 *API para traer las colonias y los CCPP
 * se usa el endpoint de colonias ya que este en su json trae incluido el CP
 *
 */
const getCpColonias = (data) => httpClient.get('https://firma.denuncia.pgjhidalgo.gob.mx/api/get-colonias?id=', data);


const postLogin = (username, password) => httpClient.post('/access_token', {
    grant_type: 'password',
    usernamePhoneEmail: username,
    password: password,
});

const refreshTokenWithKeycloak = (refreshToken) => {
    try {
        const clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID;
        const clientSecret = process.env.VUE_APP_KEYCLOAK_CLIENT_SECRET;
        const urlBase = process.env.VUE_APP_KEYCLOAK_URL_BASE;
        const realm = process.env.VUE_APP_KEYCLOAK_REALM;

        const params = new URLSearchParams();
        params.append('client_id', clientId);
        params.append('client_secret', clientSecret);
        params.append('grant_type', 'refresh_token');
        params.append('refresh_token', refreshToken);

        return axios.post(
            `${urlBase}/realms/${realm}/protocol/openid-connect/token`,
            params.toString(),
            {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }
        );

    } catch (e) {
        console.error('Error al refrescar el token con Keycloak:', e);
        throw e; // Re-lanzar el error para que pueda ser manejado por el llamador
    }

};


const postRefreshLogin = (refreshToken) => httpClient.post('/refresh_token', {
    grant_type: 'refresh_token',
    refresh_token: refreshToken
});

const postRegister = (data) => httpClient.post('usuario_registrar', data);

/**
 * Obtiene informacion del perfil de usuario
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const getUserProfile = () => httpClient.get('/usuario_perfil');

/**
 * Actualiza el perfil de usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateProfile = (data) => httpClient.post('/usuario_actualizar', data);

/**
 * Acutualiza la imagen de perfil del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateProfileAvatar = (data) => httpClient.post('/usuario_actualizar_avatar', toFormData(data));

/**
 * ACtualiza contrasenia dentro del perfil del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const updatePassword = (data) => httpClient.post('recover_password', data);

/**
 * Inicia la recuperacion de contrasenia del usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const forgotPasswordRequest = (data) => httpClient.post('usuario_recuperar_contrasena/iniciar', data);

/**
 * Finaliza la recuperacion de contrasenia, creando una nueva para el usuario usuario
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const newPassword = (data) => httpClient.post('usuario_recuperar_contrasena/finalizar', data);

/**
 * Valida que el username y el email sean unicos en la base de datos
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateUniqueCredentials = (data) => httpClient.post('/valid_unique_values', data);

/**
 * Valida que las credenciales de google no sean utilizados en algun registro previo.
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateGoogleCredentials = (username, email) => httpClient.post('/usuario_google_registrado', toFormData({
    username: username,
    email: email,
    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
}));

/**
 * Valida que las credenciales de facebook no sean utilizados en algun registro previo.
 *
 * @param username
 * @param email
 * @returns {Promise<AxiosResponse<any>>}
 */
const postValidateFacebookCredentials = (username, email) => httpClient.post('/usuario_facebook_registrado', toFormData({
    username: username,
    email: email,
    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
}));

/**
 * envia los codigos para su validacion en el backend
 *
 * @returns {Promise<AxiosResponse<any>>}
 */

const sendVerificationCode = (request) => httpClientBackend.post('/phone_confirm', request);


/**
 * Envia el codigo de verificacion de la cuenta en sesion
 *
 * @param request
 * @returns {Promise<AxiosResponse<any>>}
 */
const sendRegisterCodeFirst = (request) => httpClientBackend.post('/send_phone', request);

/**
 /**
 * Verifica si el periodo de prueba del usuario aun sigue vigente
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
const verifyTryAvailable = () => httpClient.post('/usuario_verificar_registro/periodo_prueba', {});

export {
    postLogin,
    getEstados,
    getMunicipios,
    getCpColonias,
    postRegister,
    postRefreshLogin,
    getUserProfile,
    updateProfile,
    updatePassword,
    postValidateUniqueCredentials,
    postValidateGoogleCredentials,
    postValidateFacebookCredentials,
    updateProfileAvatar,
    forgotPasswordRequest,
    newPassword,
    sendVerificationCode,
    sendRegisterCodeFirst,
    verifyTryAvailable,
    refreshTokenWithKeycloak
};